/**
 * ディスカッション（コメント・返信）ドメインスキーマ
 */
import { z } from 'zod';
// ========================================
// 基盤値オブジェクト
// ========================================
/**
 * コメント本文: 1〜5,000 文字
 */
export const CommentContentSchema = z.string().min(1).max(5000);
// ========================================
// エンティティスキーマ
// ========================================
/**
 * コメントサマリー
 */
export const CommentSummarySchema = z.object({
    commentId: z.string(),
    pluginId: z.string(),
    content: z.string(),
    authorEmail: z.string(),
    replyCount: z.number(),
    deleted: z.boolean(),
    edited: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/**
 * 返信サマリー
 */
export const ReplySummarySchema = z.object({
    replyId: z.string(),
    parentCommentId: z.string(),
    pluginId: z.string(),
    content: z.string(),
    authorEmail: z.string(),
    deleted: z.boolean(),
    edited: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
// ========================================
// リクエストスキーマ
// ========================================
/**
 * コメント作成リクエスト
 */
export const CreateCommentRequestSchema = z.object({
    content: CommentContentSchema,
});
/**
 * 返信作成リクエスト
 */
export const CreateReplyRequestSchema = z.object({
    content: CommentContentSchema,
});
/**
 * コメント/返信更新リクエスト
 */
export const UpdateCommentRequestSchema = z.object({
    content: CommentContentSchema,
});
// ========================================
// レスポンススキーマ
// ========================================
/**
 * コメント一覧レスポンス（ページネーション付き）
 */
export const CommentListResponseSchema = z.object({
    comments: z.array(CommentSummarySchema),
    total: z.number(),
    hasMore: z.boolean(),
    nextCursor: z.string().optional(),
});
/**
 * 返信一覧レスポンス
 */
export const ReplyListResponseSchema = z.object({
    replies: z.array(ReplySummarySchema),
});
/**
 * コメント詳細レスポンス
 */
export const CommentDetailResponseSchema = z.object({
    comment: CommentSummarySchema,
});
/**
 * 返信詳細レスポンス
 */
export const ReplyDetailResponseSchema = z.object({
    reply: ReplySummarySchema,
});
//# sourceMappingURL=discussion-schemas.js.map